// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39h33","content":"styles_content__3ufK5"};